import React from 'react';
import PropTypes from 'prop-types';

export default function QualityRequirementsComponent(props) {
  const {
    inviteeQreqText,
    inviterQreqText,
  } = props;

  return (
    <div className="media--root act__quality-requirements">
      {inviterQreqText && (
        <p className="act__quality-requirement">
          You must have
          {' '}
          <span dangerouslySetInnerHTML={{ __html: inviterQreqText }} />
        </p>
      )}
      {inviteeQreqText && (
        <p className="act__quality-requirement">
          They must have
          {' '}
          <span dangerouslySetInnerHTML={{ __html: inviteeQreqText }} />
        </p>
      )}
    </div>
  );
}

QualityRequirementsComponent.propTypes = {
  inviteeQreqText: PropTypes.string.isRequired,
  inviterQreqText: PropTypes.string.isRequired,
};